const cardIcons = [
  <svg
    key="no-referral"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" width="38" height="38" rx="19" fill="white" />
    <path
      d="M25.0013 11.5H15.0013C13.1596 11.5 11.668 12.9833 11.668 14.8083V23.1917C11.668 25.0167 13.1596 26.5 15.0013 26.5H25.0013C26.843 26.5 28.3346 25.0167 28.3346 23.1917V14.8083C28.3346 12.9833 26.843 11.5 25.0013 11.5ZM17.0846 14.975C18.143 14.975 19.0096 15.8417 19.0096 16.9C19.0096 17.9583 18.143 18.825 17.0846 18.825C16.0263 18.825 15.1596 17.9583 15.1596 16.9C15.1596 15.8417 16.0263 14.975 17.0846 14.975ZM20.3096 22.8833C20.2346 22.9667 20.118 23.0167 20.0013 23.0167H14.168C14.0513 23.0167 13.9346 22.9667 13.8596 22.8833C13.7846 22.8 13.743 22.6833 13.7513 22.5667C13.893 21.1667 15.0096 20.0583 16.4096 19.925C16.8513 19.8833 17.3096 19.8833 17.7513 19.925C19.1513 20.0583 20.2763 21.1667 20.4096 22.5667C20.4263 22.6833 20.3846 22.8 20.3096 22.8833ZM25.8346 22.9583H24.168C23.8263 22.9583 23.543 22.675 23.543 22.3333C23.543 21.9917 23.8263 21.7083 24.168 21.7083H25.8346C26.1763 21.7083 26.4596 21.9917 26.4596 22.3333C26.4596 22.675 26.1763 22.9583 25.8346 22.9583ZM25.8346 19.625H22.5013C22.1596 19.625 21.8763 19.3417 21.8763 19C21.8763 18.6583 22.1596 18.375 22.5013 18.375H25.8346C26.1763 18.375 26.4596 18.6583 26.4596 19C26.4596 19.3417 26.1763 19.625 25.8346 19.625ZM25.8346 16.2917H21.668C21.3263 16.2917 21.043 16.0083 21.043 15.6667C21.043 15.325 21.3263 15.0417 21.668 15.0417H25.8346C26.1763 15.0417 26.4596 15.325 26.4596 15.6667C26.4596 16.0083 26.1763 16.2917 25.8346 16.2917Z"
      fill="#252392"
    />
  </svg>,

  <svg
    key="convenience"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.75" width="38" height="38" rx="19" fill="white" />
    <path
      d="M24.0833 10.666H17.4167C14.5 10.666 13.25 12.3327 13.25 14.8327V23.166C13.25 25.666 14.5 27.3327 17.4167 27.3327H24.0833C27 27.3327 28.25 25.666 28.25 23.166V14.8327C28.25 12.3327 27 10.666 24.0833 10.666ZM17.4167 19.2077H20.75C21.0917 19.2077 21.375 19.491 21.375 19.8327C21.375 20.1743 21.0917 20.4577 20.75 20.4577H17.4167C17.075 20.4577 16.7917 20.1743 16.7917 19.8327C16.7917 19.491 17.075 19.2077 17.4167 19.2077ZM24.0833 23.791H17.4167C17.075 23.791 16.7917 23.5077 16.7917 23.166C16.7917 22.8243 17.075 22.541 17.4167 22.541H24.0833C24.425 22.541 24.7083 22.8243 24.7083 23.166C24.7083 23.5077 24.425 23.791 24.0833 23.791ZM26.1667 16.7077H24.5C23.2333 16.7077 22.2083 15.6827 22.2083 14.416V12.7493C22.2083 12.4077 22.4917 12.1243 22.8333 12.1243C23.175 12.1243 23.4583 12.4077 23.4583 12.7493V14.416C23.4583 14.991 23.925 15.4577 24.5 15.4577H26.1667C26.5083 15.4577 26.7917 15.741 26.7917 16.0827C26.7917 16.4243 26.5083 16.7077 26.1667 16.7077Z"
      fill="#252392"
    />
  </svg>,

  <svg
    key="treatment"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" width="38" height="38" rx="19" fill="white" />
    <path
      d="M21.0013 15.875C19.5096 15.875 18.293 17.0917 18.293 18.5833C18.293 20.075 19.5096 21.2917 21.0013 21.2917C22.493 21.2917 23.7096 20.075 23.7096 18.5833C23.7096 17.0917 22.493 15.875 21.0013 15.875ZM21.8346 18.3167C21.8346 18.825 21.5596 19.3083 21.1263 19.5667L20.4846 19.95C20.3846 20.0083 20.2763 20.0417 20.1596 20.0417C19.9513 20.0417 19.743 19.9333 19.6263 19.7417C19.4513 19.4417 19.543 19.0583 19.843 18.8833L20.4763 18.5C20.543 18.4583 20.5763 18.3917 20.5763 18.325V17.55C20.5763 17.2083 20.8596 16.925 21.2013 16.925C21.543 16.925 21.8346 17.2 21.8346 17.5417V18.3167Z"
      fill="#252392"
    />
    <path
      d="M26.4487 12.4749L21.8654 10.7582C21.3904 10.5832 20.6154 10.5832 20.1404 10.7582L15.557 12.4749C14.6737 12.8082 13.957 13.8415 13.957 14.7832V21.5332C13.957 22.2082 14.3987 23.0999 14.9404 23.4999L19.5237 26.9249C20.332 27.5332 21.657 27.5332 22.4654 26.9249L27.0487 23.4999C27.5904 23.0915 28.032 22.2082 28.032 21.5332V14.7832C28.0404 13.8415 27.3237 12.8082 26.4487 12.4749ZM20.9987 22.5415C18.8154 22.5415 17.0404 20.7665 17.0404 18.5832C17.0404 16.3999 18.8154 14.6249 20.9987 14.6249C23.182 14.6249 24.957 16.3999 24.957 18.5832C24.957 20.7665 23.182 22.5415 20.9987 22.5415Z"
      fill="#252392"
    />
  </svg>,

  <svg
    key="no-commitment"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" width="38" height="38" rx="19" fill="white" />
    <path
      d="M18.332 21.916C17.9904 21.916 17.707 22.1993 17.707 22.541V23.791C17.707 24.1327 17.9904 24.416 18.332 24.416C18.6737 24.416 18.957 24.1327 18.957 23.791V22.541C18.957 22.1993 18.6737 21.916 18.332 21.916Z"
      fill="#252392"
    />
    <path
      d="M28.3346 26.7092H27.5013V17.3176C27.5013 16.8009 27.268 16.3176 26.8596 16.0009L21.0263 11.4676C20.4263 10.9926 19.5763 10.9926 18.9763 11.4676L13.143 16.0009C12.7346 16.3176 12.5013 16.8009 12.5013 17.3092L12.4596 26.7092H11.668C11.3263 26.7092 11.043 26.9842 11.043 27.3342C11.043 27.6759 11.3263 27.9592 11.668 27.9592H28.3346C28.6763 27.9592 28.9596 27.6759 28.9596 27.3342C28.9596 26.9842 28.6763 26.7092 28.3346 26.7092ZM18.7513 14.6259H21.2513C21.593 14.6259 21.8763 14.9092 21.8763 15.2509C21.8763 15.5926 21.593 15.8759 21.2513 15.8759H18.7513C18.4096 15.8759 18.1263 15.5926 18.1263 15.2509C18.1263 14.9092 18.4096 14.6259 18.7513 14.6259ZM24.168 26.7092H15.8346V19.4176C15.8346 18.7259 16.393 18.1676 17.0846 18.1676H22.918C23.6096 18.1676 24.168 18.7259 24.168 19.4176V26.7092Z"
      fill="#252392"
    />
  </svg>,

  <svg
    key="secure"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" width="38" height="38" rx="19" fill="white" />
    <path
      d="M23.3333 10.666H16.6667C13.75 10.666 12.5 12.3327 12.5 14.8327V23.166C12.5 25.666 13.75 27.3327 16.6667 27.3327H23.3333C26.25 27.3327 27.5 25.666 27.5 23.166V14.8327C27.5 12.3327 26.25 10.666 23.3333 10.666ZM20.8917 21.9077C20.4667 23.266 18.975 23.9743 18.5583 23.9743C18.15 23.966 16.675 23.2743 16.2333 21.9077C15.9583 21.0493 16.2833 19.991 17.175 19.6993C17.65 19.5493 18.2333 19.6743 18.5583 20.1327C18.8667 19.6577 19.475 19.5493 19.9417 19.6993C20.8417 19.991 21.1583 21.0493 20.8917 21.9077ZM25.4167 16.7077H23.75C22.4833 16.7077 21.4583 15.6827 21.4583 14.416V12.7493C21.4583 12.4077 21.7417 12.1243 22.0833 12.1243C22.425 12.1243 22.7083 12.4077 22.7083 12.7493V14.416C22.7083 14.991 23.175 15.4577 23.75 15.4577H25.4167C25.7583 15.4577 26.0417 15.741 26.0417 16.0827C26.0417 16.4243 25.7583 16.7077 25.4167 16.7077Z"
      fill="#252392"
    />
  </svg>,
];

/** Outline icons for compact hero info chips (calendar / clock / timer / ticket). */
export const chipIcons = [
  <svg
    key="chip-calendar"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8 2v2M16 2v2M3.5 9h17M6 4h12a2.5 2.5 0 0 1 2.5 2.5v13A2.5 2.5 0 0 1 18 22H6a2.5 2.5 0 0 1-2.5-2.5v-13A2.5 2.5 0 0 1 6 4Z"
      stroke="#252392"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    key="chip-clock"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" stroke="#252392" strokeWidth="1.75" />
    <path
      d="M12 7v5.5l3.5 2"
      stroke="#252392"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  <svg
    key="chip-timer"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 2h4M12 14V9"
      stroke="#252392"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <circle cx="12" cy="14" r="8" stroke="#252392" strokeWidth="1.75" />
  </svg>,
  <svg
    key="chip-ticket"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3 9a2 2 0 0 0 2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 1 0 0 4v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2Z"
      stroke="#252392"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <path
      d="M9 8v8"
      stroke="#252392"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeDasharray="1.5 3"
    />
  </svg>,
];

export default cardIcons;
